import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class DownloadDocumentService {
  constructor(private http: HttpClient) {}

  /**
   * @description Downloads the file based on the migrated_fl = 1 flag from the AWS S3 bucket.
   * @param string fileName
   * @returns DOWNLOADS DOCUMENT
   * @memberof DownloadDocumentService
   */
  downloadFile(fileName: string, item: any) {
    return window.open(
      "/api/InternalPersonDocument/downloadRequestDetailDocument?file=" +
        fileName +
        "&personId=" +
        item.PERSON_ID +
        "&requestId=" +
        item.REQUEST_ID
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/common/services/downloaddocument.service.ts